// Module
var code = "<div class=\"clickable no-underline pull-right stats-toggle\" ng-click=\"toggleStats()\" ng-class=\"{ 'relative': relative }\"> <i class=\"icomoon-stats-dots\"></i> <span ng-if=\"open\">{{openedText}}</span> <span ng-if=\"!open\">{{closedText}}</span> <i class=\"ionicons\" ng-class=\"{'ion-chevron-up': open, 'ion-chevron-down': !open}\"></i> </div> ";
// Exports
var _module_exports =code;;
var path = '/views/stats-toggle.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;